import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { fetchProfileIfNeeded } from 'data/actions/profile';

import Profile from 'components/templates/profile';

class ProfileContainer extends Component {
    componentDidMount() {
        this.props.fetchProfileIfNeeded();
    }

    componentDidUpdate(prevProps, prevState) {}

    render() {
        return <Profile {...this.props} />;
    }
}

const mapStateToProps = (state, ownProps) => {
    const profile = state.profile.content;
    return {
        path: ownProps.match.url,
        body: profile.body,
        image: {
            title: profile.image.fields.title,
            url: profile.image.fields.file.url
        },
        phoneNumber: profile.phoneNumber,
        emailAddress: profile.emailAddress,
        kitlist: profile.kitlist,
        hasLoaded: state.profile.hasLoaded,
        hasError: state.profile.hasError,
        isLoading: state.profile.isLoading
    };
};

ProfileContainer = withRouter(
    connect(mapStateToProps, { fetchProfileIfNeeded })(ProfileContainer)
);

export default ProfileContainer;



// WEBPACK FOOTER //
// ./src/data/containers/profilePage.js